import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Door} from '../classes/Door';
import {environment} from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class DoorService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Door[]> {
    return this.httpClient.get<Door[]>(`${environment.backendApiUrl}/v1/doors`, httpOptions);
  }

  public save(room: Door): Observable<void> {
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/doors`, room, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/doors/` + id, httpOptions);
  }
}
